class SodTestimonialRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.sod-tst__track');
    if (!this.track) return;

    this.cards = Array.from(this.querySelectorAll('.sod-tst-card'));
    this.arrows = Array.from(this.querySelectorAll('[data-scroll]'));

    this.arrows.forEach((a) => a.addEventListener('click', this.onArrow));
    this.track.addEventListener('scroll', this.syncArrows, { passive: true });
    this.syncArrows();
  }

  disconnectedCallback() {
    this.arrows?.forEach((a) => a.removeEventListener('click', this.onArrow));
    this.track?.removeEventListener('scroll', this.syncArrows);
  }

  onArrow = (event) => {
    const direction = Number(event.currentTarget.dataset.scroll) || 1;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const step = (this.cards[0]?.getBoundingClientRect().width || this.track.clientWidth) + gap;
    this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
  };

  syncArrows = () => {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const max = scrollWidth - clientWidth - 1;
    this.arrows.forEach((a) => {
      const forward = Number(a.dataset.scroll) > 0;
      a.toggleAttribute('disabled', forward ? scrollLeft >= max : scrollLeft <= 0);
    });
  };
}

if (!customElements.get('sod-testimonial-rail')) {
  customElements.define('sod-testimonial-rail', SodTestimonialRail);
}
